export default __webpack_public_path__ + "static/Montserrat-Bold-5fd5a854f83973683f952afbeeab8acf.woff";